var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconHuawei = function SvgIconHuawei(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.943 2.357h8.12c3.83 0 5.224 1.448 5.224 5.424v8.43c0 3.977-1.402 5.432-5.224 5.432h-8.12c-3.83 0-5.232-1.456-5.232-5.432v-8.43c0-3.976 1.402-5.424 5.232-5.424Zm2.472 12.158.225-.52h1.106l.218.52h.515l-1.066-2.518h-.432l-1.066 2.518h.5Zm1.147-.976h-.745l.371-.9.374.9Zm7.66-1.542h-.493v2.518h.493v-2.518Zm-1.074 2.061h-1.351v-.621h.896v-.465h-.896v-.511h1.298v-.464h-1.783v2.518h1.836v-.457Zm-2.233-2.061H15.4l-.536 1.736-.553-1.736h-.405l-.545 1.736-.538-1.736h-.53l.85 2.525h.405l.553-1.657.553 1.657h.417l.844-2.525Zm-6.253 0H9.17v1.445c0 .409-.195.634-.554.634-.358 0-.553-.225-.553-.65v-1.427H7.57v1.44c0 .71.382 1.123 1.039 1.123.672 0 1.053-.417 1.053-1.139v-1.426Zm-2.776 0h-.493v1.015H5.282v-1.015h-.493v2.525h.493v-1.03h1.111v1.03h.493v-2.525ZM8.914 5.58c0 1.768 1.38 3.208 3.09 3.208 1.703 0 3.09-1.443 3.09-3.208h-.432c0 1.519-1.195 2.751-2.658 2.751-1.463 0-2.658-1.232-2.658-2.75h-.432Z",
    fill: "currentColor"
  })));
};

export default SvgIconHuawei;